'use client';
import { createContext, useContext } from 'react';
export const CanonicalPageContext = createContext({
    inApp: false,
    preferredColorScheme: null,
    deviceId: null,
    appVersion: null,
    isIOS: false,
    isAndroid: false,
    client: null,
});
CanonicalPageContext.displayName = 'CanonicalPageContext';
export function useGetCanonicalPageContext() {
    return useContext(CanonicalPageContext);
}
//# sourceMappingURL=CanonicalProviderShared.js.map